import { useMemo, useRef } from 'react';
import { FaceSummary } from './types';

/** Keep a row in place while its panel count changes or another roof is selected. */
const useStableFaceOrder = (summaries: FaceSummary[]): FaceSummary[] => {
  const orderRef = useRef<number[]>([]);
  return useMemo(() => {
    const byId = new Map(summaries.map((summary) => [summary.faceId, summary]));
    const known = new Set(orderRef.current);
    const kept = orderRef.current;
    const fresh = summaries
      .filter((summary) => !known.has(summary.faceId))
      .sort(
        (a, b) =>
          b.panelsIncluded - a.panelsIncluded ||
          (b.annualKwh ?? -1) - (a.annualKwh ?? -1) ||
          a.faceId - b.faceId
      )
      .map((summary) => summary.faceId);
    orderRef.current = [...kept, ...fresh];
    return orderRef.current
      .map((faceId) => byId.get(faceId))
      .filter((summary): summary is FaceSummary => !!summary);
  }, [summaries]);
};

export default useStableFaceOrder;
